import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prescripteur-card',
  templateUrl: './prescripteur-card.component.html',
  styleUrls: ['./prescripteur-card.component.scss']
})
export class PrescripteurCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
